import React, { useState, useEffect, useRef } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { useLogo } from '../../hooks/useLogo';

export default function Header({ location, onLocationClick, locationDenied }) {
  const logo = useLogo();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const username = localStorage.getItem('email') || 'User';
  const initial = username.charAt(0).toUpperCase();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  return (
    <header className="w-full px-4 sm:px-8 py-2">
      <div className="max-w-4xl mx-auto bg-dark/90 text-white rounded-md px-4 py-2 flex items-center justify-between">
        {/* Left: Logo */}
        <img src={logo} alt="Logo" className="h-8 max-w-[80px] object-contain" />

        <div
          onClick={locationDenied ? onLocationClick : undefined}
          className={`text-xs sm:text-sm text-center ${
            locationDenied ? 'cursor-pointer text-primary hover:underline' : ''
          }`}
          title={locationDenied ? 'Click to enable location' : ''}
        >
          <div className="flex items-center gap-1 justify-center">
            <FaMapMarkerAlt className="text-primary" />
            <span>
              Lat: {location?.lat || 'Unavailable'}
              <span className="hidden sm:inline"> | </span>
              <span className="block sm:inline">Lon: {location?.lon || 'Unavailable'}</span>
            </span>
          </div>
        </div>

        {/* Right: Profile */}
        <div className="relative" ref={dropdownRef}>
          <div
            className="bg-primary text-white w-8 h-8 flex items-center justify-center rounded-full text-xs font-bold cursor-pointer"
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            {initial}
          </div>

          {showDropdown && (
            <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-lg border text-sm z-50">
              <div className="px-4 py-2 text-gray-800 border-b font-medium break-all max-w-[180px]">{username}</div>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
              >
                Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
